enum KBContentType {
    TOC = 1,
	Page = 2
}

export default KBContentType;



